import React from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";

const ScreenLock = ({ onOpen, onClose }) => {
  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="500px">
        <div className="text-center">
          <h3 className="text-5xl text-red-700 text-center py-4  font-light">
            Access Denied
          </h3>
          <p className="font-extralight text-lg py-2">
            Activate Subscription to get complete Access
          </p>
          <CustomButton
            variant={"ok"}
            buttonType={"primary"}
            buttonText={"Activate Now"}
            className={"w-40 h-14 my-4"}
            onClick={() => alert("Go to Subcriptions page")}
          />
        </div>
      </DialogBox>
    </div>
  );
};

export default ScreenLock;
